import {
  BrowserRouter as Routes,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import CONFIG from '../../config'
import { RouteAuthed, RouteSolem } from './'
import { HomePage, RegisterPage, RegisterRutPage, RegisterPassportPage, ForgotPasswordPage, AdminAlertsPage } from '../pages'
import { 
  AdminHomePage, 
  AdminUsersPage, 
  AdminUserCreatePage, 
  AdminUserEditPage, 
  AdminControlPreventionPage, 
  AdminControlPreventionCreatePage, 
  AdminControlPreventionEditPage, 
  AdminMailingPage,
  AdminAdsHomePage,
  AdminAdsCreatePage,
  AdminAdsEditPage,
} from '../pages/Admin'
import { SummaryPage, ProfilePage, MedicalAppointmentPage, FamilyGroupPage, FamilyGroupFormPage, FamilyGroupAcceptPage, FamilyGroupRejectedPage, RequestPage, ContactPage, BudgetRequestPage, ExamsProceduresPage, ControlPreventionPage, SchedulePage } from '../pages/Dashboard'
import { AdminFamilyPage, AdminManageFamilyPage, AdminAddMemberFamilyPage } from '../modules/admin-family/pages';

const Router = () => (
  <Routes>
    <Switch>
      <Route path={CONFIG.ROUTES.HOME} exact component={HomePage} />
      <Route path={CONFIG.ROUTES.AUTH.REGISTER.HOME} exact component={RegisterPage} />
      <RouteSolem path={CONFIG.ROUTES.AUTH.REGISTER.RUT} exact component={RegisterRutPage} />
      <Route path={CONFIG.ROUTES.AUTH.REGISTER.PASSPORT} exact component={RegisterPassportPage} />
      <Route path={CONFIG.ROUTES.AUTH.FORGOTPASSWORD} exact component={ForgotPasswordPage} />

      <Route path={'/accepted/:document_type/:document_number/:name'} exact component={FamilyGroupAcceptPage} />
      <Route path={'/rejected/:document_type/:document_number/:name'} exact component={FamilyGroupRejectedPage} />

      <Route path={CONFIG.ROUTES.ADMIN.HOME} exact component={AdminHomePage} />
      <Route path={CONFIG.ROUTES.ADMIN.FORGOTPASSWORD} exact>
        <ForgotPasswordPage role="ADMIN_ROLE" />
      </Route>
      <RouteAuthed path={CONFIG.ROUTES.ADMIN.USERS.HOME} exact role="ADMIN_ROLE" component={AdminUsersPage} />
      <RouteAuthed path={`${CONFIG.ROUTES.ADMIN.USERS.CREATE.MAIN}/:role`} exact role="ADMIN_ROLE" component={AdminUserCreatePage} />
      <RouteAuthed path={`${CONFIG.ROUTES.ADMIN.USERS.EDIT}/:id`} exact role="ADMIN_ROLE" component={AdminUserEditPage} />
      <RouteAuthed path={CONFIG.ROUTES.ADMIN.FAMILY.HOME} exact role="ADMIN_ROLE" component={AdminFamilyPage} />
      <RouteAuthed path={`${CONFIG.ROUTES.ADMIN.FAMILY.HOME}/:leader_id`} exact role="ADMIN_ROLE" component={AdminManageFamilyPage} />
      <RouteAuthed path={`${CONFIG.ROUTES.ADMIN.FAMILY.ADDMEMBER}/:leader_id`} exact role="ADMIN_ROLE" component={AdminAddMemberFamilyPage} />
      <RouteAuthed path={CONFIG.ROUTES.ADMIN.CONTROLPREVENTION.HOME} exact role="SUPER_ADMIN_ROLE" component={AdminControlPreventionPage} />
      <RouteAuthed path={CONFIG.ROUTES.ADMIN.CONTROLPREVENTION.CREATE} exact role="SUPER_ADMIN_ROLE" component={AdminControlPreventionCreatePage} />
      <RouteAuthed path={`${CONFIG.ROUTES.ADMIN.CONTROLPREVENTION.EDIT}/:id`} exact role="SUPER_ADMIN_ROLE" component={AdminControlPreventionEditPage} />
      <RouteAuthed path={CONFIG.ROUTES.ADMIN.ALERTS} exact role="SUPER_ADMIN_ROLE" component={AdminAlertsPage} />
      <RouteAuthed path={CONFIG.ROUTES.ADMIN.MAILING} exact role="SUPER_ADMIN_ROLE" component={AdminMailingPage} />
      <RouteAuthed path={CONFIG.ROUTES.ADMIN.ADS.HOME} exact role="SUPER_ADMIN_ROLE" component={AdminAdsHomePage} />
      <RouteAuthed path={CONFIG.ROUTES.ADMIN.ADS.CREATE} exact role="SUPER_ADMIN_ROLE" component={AdminAdsCreatePage} />
      <RouteAuthed path={`${CONFIG.ROUTES.ADMIN.ADS.EDIT}/:id`} exact role="SUPER_ADMIN_ROLE" component={AdminAdsEditPage} />

      <RouteAuthed path={CONFIG.ROUTES.DASHBOARD.HOME} exact component={SummaryPage} />
      <RouteAuthed path={CONFIG.ROUTES.DASHBOARD.PROFILE} exact component={ProfilePage} />
      <RouteAuthed path={`${CONFIG.ROUTES.DASHBOARD.MEDICALAPPOINTMENTS.HOME}/:id?`} exact component={MedicalAppointmentPage} />
      <RouteAuthed path={`${CONFIG.ROUTES.DASHBOARD.FAMILYGROUP.HOME}`} exact component={FamilyGroupPage} />
      <RouteAuthed path={`${CONFIG.ROUTES.DASHBOARD.FAMILYGROUP.ADDMEMBER}`} exact component={FamilyGroupFormPage} />
      <RouteAuthed path={`${CONFIG.ROUTES.DASHBOARD.REQUESTS}`} exact component={RequestPage} />
      <RouteAuthed path={`${CONFIG.ROUTES.DASHBOARD.CONTACT}`} exact component={ContactPage} />
      <RouteAuthed path={`${CONFIG.ROUTES.DASHBOARD.BUDGETREQUEST}`} exact component={BudgetRequestPage} />
      <RouteAuthed path={`${CONFIG.ROUTES.DASHBOARD.EXAMSPROCEDURES.HOME}/:id?`} exact component={ExamsProceduresPage} />
      <RouteAuthed path={`${CONFIG.ROUTES.DASHBOARD.CONTROLPREVENTION}`} exact component={ControlPreventionPage} />
      <RouteAuthed path={`${CONFIG.ROUTES.DASHBOARD.SCHEDULE}`} exact component={SchedulePage} />

      <Redirect to="/" />
    </Switch>
  </Routes>
)

export default Router;
